type ProdutoInfo = {
  descricao?: string;
};

type Produtos = {
  principal?: ProdutoInfo;
  quantidade?: number;
};

type Lotes = {
  lista?: string[];
};

type Item = {
  status: "fora" | "ideal" | "tolerancia" | string;
  bico: number | string;
  produtos?: Produtos;
  lotes?: Lotes;
  operadora?: string;
  media: number;
  abaixo: number;
  acima: number;
  pesagens: number;
  ideais: number;
  min: number;
  max: number;
  tolerancia: number;
};

type BicoCardProps = {
  item: Item;
};

function bgByStatus(status: Item["status"]) {
  switch (status) {
    case "fora":
      return "bg-gradient-to-br from-red-200 to-red-400 text-white";
    case "ideal":
      return "bg-gradient-to-br from-green-100 to-green-300";
    case "tolerancia":
      return "bg-gradient-to-br from-yellow-100 to-yellow-300";
    default:
      return "bg-slate-200";
  }
}

function formatColaboradores(nomes?: string): string {
  if (!nomes) return "";

  return nomes
    .split(",")
    .map((nome) => {
      let partes = nome.trim().split(/\s+/);

      // Se começar com número e traço, mantém isso separado
      let prefixo = "";
      if (/^\d+$/.test(partes[0])) {
        prefixo = partes[0]; // número
        partes.shift();
        if (partes[0] === "-") {
          prefixo += " -";
          partes.shift();
        }
      }

      if (partes.length === 0) return prefixo;

      const primeiro = partes[0];
      const ultimo = partes.length > 1 ? partes[partes.length - 1] : "";

      return (
        (prefixo ? prefixo + " " : "") +
        primeiro.charAt(0).toUpperCase() +
        primeiro.slice(1).toLowerCase() +
        (ultimo
          ? " " + ultimo.charAt(0).toUpperCase() + ultimo.slice(1).toLowerCase()
          : "")
      );
    })
    .join(", ");
}

export default function BicoCard({ item }: BicoCardProps) {
  return (
    <div className={`rounded-xl card-shadow p-3 w-full sm:w-64 ${bgByStatus(item.status)}`}>
      <div className="text-slate-900">
        <div className="flex justify-between items-start">
          <h3 className="text-xl font-bold">BICO {String(item.bico).padStart(2, "0")}</h3>

          {/* {item?.produtos?.principal ? (
            <div className="mt-1 text-[11px] text-slate-600">
              {item.produtos.principal.descricao}
              {item.lotes?.lista?.length ? ` · Lotes: ${item.lotes.lista.join(", ")}` : null}
            </div>
          ) : item?.produtos?.quantidade && item.produtos.quantidade > 1 ? (
            <div className="mt-1 text-[11px] text-amber-700">
              Mix de produtos no período ({item.produtos.quantidade})
            </div>
          ) : null} */}
          <span className="text-xs">{formatColaboradores(item.operadora)}</span>
        </div>
        <div className="mt-1">
          <div className="text-lg font-semibold">Média: {item.media.toFixed(1)}g</div>
          <ul className="text-sm mt-2 space-y-1">
            <li>Abaixo do peso: {item.abaixo}%</li>
            <li>Acima do peso: {item.acima}%</li>
            <li>Pesagens: {item.pesagens}</li>
            <li>Peso ideal: {item.ideais}%</li>
            <li>Menor peso: {item.min.toFixed(1)}g</li>
            <li>Maior peso: {item.max.toFixed(1)}g</li>
            <li>Tolerância: {item.tolerancia}%</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
